const INVENTORY_LEVEL_LOCATIONS = (store) => {
  let correctOrder;
  switch (store) {
    case 'gb_store':
      correctOrder = {
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'SUW': 'Source USA Warehouse',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'SO': 'Special Order',
        'GW': 'Germany Warehouse'
      }
      break;
    case 'eu_store':
      correctOrder = {
        'GW': 'Germany Warehouse',
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'SUW': 'Source USA Warehouse',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'SO': 'Special Order'
      }
      break;
    case 'us_store':
      correctOrder = {
        'SUW': 'Source USA Warehouse',
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUSA': 'Suppliers USA',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'USADS': 'USA Drop Ship',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'SO': 'Special Order',
        'GW': 'Germany Warehouse'
      }
      break;
    case 'row_store':
      correctOrder = {
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'SUW': 'Source USA Warehouse',
        'SUSA': 'Suppliers USA',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'SO': 'Special Order',
        'GW': 'Germany Warehouse'
      }
      break;
    case 'am_store':
      correctOrder = {
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'SUW': 'Source USA Warehouse',
        'SUSA': 'Suppliers USA',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'SO': 'Special Order',
        'GW': 'Germany Warehouse'
      }
      break;
    default:
      correctOrder = {
        'SHQ': 'Source HQ',
        'SPS': 'Source Park (Shop)',
        'SUW': 'Source USA Warehouse',
        'SO': 'Special Order',
        'SUP': 'Suppliers',
        'SUPL': 'Suppliers Local',
        'SUSA': 'Suppliers USA',
        'USAS': 'USA Shop',
        'USADS': 'USA Drop Ship',
        'IS': 'In Stock',
        '12D': '1-2 Days',
        '24D': '2-4 Days',
        '57D': '5-7 Days',
        '710D': '7-10 Days',
        'GW': 'Germany Warehouse'
      }
      break;
  }

  return correctOrder
}

export default INVENTORY_LEVEL_LOCATIONS
